import { Permission } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';
import { getRiskScoreProjectionConfig } from '@views/RiskScore/useRiskScorePermissions';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score/edit/$projectionId')({
  beforeLoad: ({ context, params }) => {
    const projectionConfig = getRiskScoreProjectionConfig(params.projectionId as any);
    const canUpdate = projectionConfig
      ? context.userPermissions.hasAllowedPermissionToResource({
          resource: projectionConfig.permissionResource,
          permission: Permission.UPDATE,
        })
      : false;
    const title = canUpdate ? 'Edit Factors' : 'Factors';
    return getTitleContextSlice(title, { preserveSearchParams: true });
  },
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
